import { TFunction } from "i18next";

export interface IRideStationStopIndicatorState {
  className: string;
  tooltip: string;
}

/**
 * Resolves the "stop at station" indicator's color class + tooltip from the GPS-derived conditions.
 * Kept out of the component so the mapping isn't re-created on every render. First active condition
 * wins; falls back to the "not reached" (gray) state.
 */
export const getRideStationStopIndicatorState = ({
  hasPassedWithoutStopping,
  hasStopped,
  t,
}: {
  hasPassedWithoutStopping: boolean;
  hasStopped: boolean;
  t: TFunction;
}): IRideStationStopIndicatorState => {
  const states = [
    {
      active: hasStopped,
      className: "stop-indicator--stopped",
      tooltipKey: "ride.INDICATORS.stoppedAtStationYes",
    },
    {
      active: hasPassedWithoutStopping,
      className: "stop-indicator--passed",
      tooltipKey: "ride.INDICATORS.passedWithoutStopping",
    },
  ];

  const matched = states.find(state => state.active);

  const indicatorState: IRideStationStopIndicatorState = {
    className: matched?.className ?? "stop-indicator--not-stopped",
    tooltip: t(matched?.tooltipKey ?? "ride.INDICATORS.stoppedAtStationNo"),
  };
  return indicatorState;
};
